<template>
  <div><!--最外层DIV-->
    <div><!--内容DIV-->
      <div class="loginForm">
        <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
            添加系统后台公告信息
          </span>
          <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
            <a href="javascript:;" @click="NotSaveEnclosure()">
              <i class="el-icon-close"></i>
            </a>
          </span>
        </div>
        <el-dialog title="附件上传" :visible.sync="dialogTableVisible">
          <div style="min-height: 400px;overflow: hidden;">
            <div style="float: left;width: 50%;">
              <el-upload
                class="upload-demo"
                ref="upload_music"
                action="/api/AddEnclosure"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="handleAvatarSuccess"
                :on-change="onchange"
                :before-upload="beforeupload"
                :data="AddForm"
                :headers="myHeaders"
                :file-list="fileLists"
                :limit="5">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <div slot="tip" class="el-upload__tip">文件不能超过10MB，最多5个附件</div>
              </el-upload>
            </div>
            <div style="float: left;width: 50%;">
              已上传文件
              <el-table :data="fileData" style="width: 100%">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="name" label="操作" width="70">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="deletes(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-dialog>
        <div style="width: 650px;margin: 0 auto;">
          <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 20px;">
            <el-form-item prop="title">
              <el-input type="text" v-model="AddForm.title" placeholder="通知标题">
                <template slot="append">
                  <el-button @click="dialogTableVisible = true">附件</el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="content">
              <mavon-editor style="height: 450px;" ref=md v-model="content" @imgAdd="imgAdd" @imgDel="imgDel" @save="AddLabel"></mavon-editor>
            </el-form-item>
          </el-form>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import axios from 'axios' //引入axios
  let Atoken=sessionStorage.getItem("Atoken")
  export default {
    props: {
        url: {
          type: String,
          default: ''
        },
        div_name: {
          type: String,
          default: ''
        }
      },
    data() {
      var title = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入标题'))
        } else {
          callback()
        }
      }
      return {
        formInline:{
          enclosurecol_i:"",
        },
        fileData:[],
        fileLists:[],
        myHeaders: {
          Atoken:Atoken,
        },
        dialogTableVisible:false,
        content:'',
        AddForm:{
          admin_id:'',
          title:'',
          content:'',
          message_id:'',
          enclosurecol_i_id:'',
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
            validator: title
          }]
        },
        //取消保存
        NoSave:{
          list:''
        },
        //回调数据
        returnes:{
          returns:'',
        },
      }
    },
    //页面开启时执行
    mounted(){
      //
      //赋值
      this.AddForm.admin_id=this.$store.state.a_id;
      this.AddForm.enclosurecol_i_id="FJ"+(new Date()).valueOf();
    },
    methods: {
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteEnclosure',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.queryEcn_list();
            //删除列表数据
            /**
            for(let i=0;i<this.fileLists.length;i++){
              if(this.fileLists.name==row.name){
                this.fileLists.splice(i, 1);
              }
            }
            */
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //获取当前已经上传的文件
      queryEcn_list(){
        this.formInline.enclosurecol_i=this.AddForm.enclosurecol_i_id;
        commonAPI('queryEnclosureList',this.formInline).then(res => {
          this.loading = false;
          this.fileData = res.data.data.rows;
          //console.log(res.data.rows);
        })
      },
      //文件的上传
      onchange(file, fileList){
        this.fileLists=fileList;
      },
      beforeupload(file){
        //判定是否有新的值
        if(this.AddForm.enclosurecol_i_id==""){
          this.AddForm.enclosurecol_i_id="FJ"+(new Date()).valueOf();
        }
        //判定是否数量到头
        if(this.fileData.length>=5){
          this.$confirm('最多上传5个文件');
          return false;
        }
        //
        let k=0;
        for(let i=0;i<this.fileLists.length;i++){
          if(file.name==this.fileLists[i].name){
            k=k+1;
          }
        }
        if(k>1){
          this.$confirm('请勿重复上传');
          return false;
        }
      },
      handleRemove(file, fileList) {
        //return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleAvatarSuccess(res, file) {
        let data = res;
        if(data.info.code=='1000'){
          this.handleAvatarSuccess_sql(data.data);
        }
      },
      //上传成功进行回调
      handleAvatarSuccess_sql(datas){
        this.returnes.returns=datas
        commonAPI('AddEnclosure_sql',this.returnes).then(res => {
          let data=res.data;
          if(this.response.response(data)){
            this.queryEcn_list();
          }
        })
      },
      //新的通知方法
      imgAdd(name, file) {
        var formdata = new FormData();
        formdata.append('image', file);
        axios({
          url: '/api/AddAboutIMG',
          method: 'post',
          data: formdata,
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then((res) => {
          let url=res.data.data
          this.$refs.md.$img2Url(name, url);
        })
      },
      imgDel(name){
        console.log("name内容:" + name);
      },
      //添加内容
      AddLabel(markdown, html){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          if(this.content.length<=0){
            this.$message({
              message: '请填写内容后再保存',
              type: 'warning'
            });
            return false;
          }
          //this.aboutdata.type="update";
          this.AddForm.content=html;
          //console.log(index, row);
          commonAPI(this.url,this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.$emit('childFn', "");
              this.close();
              //this.getData();
            }
          }).catch(error=>{
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '提示',
                message: error.message,
                position: 'bottom-right',
                type: 'error'
              });
            })
        }else{
          return false;
        }
        })
      },
      close(){
        this.AddForm.title='';
        this.content='';
        this.AddForm.enclosurecol_i_id="";
        this.fileData=[];
        document.getElementById(this.div_name).style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //取消保存
      NotSaveEnclosure(){
        if(this.fileData.length<=0){
          this.close();
          return false;
        }
        this.NoSave.list=this.fileData;
        commonAPI('NotSaveEnclosure',this.NoSave).then(res => {
          this.close();
          /**
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.$emit('childFn', "");
            this.close();
            //this.getData();
          }
          */
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
          })
      },
    }
  }
</script>

<style scoped>
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 700px;
    max-height: 600px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/A_zujian/Notice.vue